module.exports = __webpack_public_path__ + "static/media/sinister_type_crash.80710302.svg";